import React, { useState } from "react";
import { Button, Dialog, DialogContent, Snackbar, Alert } from "@mui/material";
import TpAddUser from "./TpAddUser";
import ModalDialogTitle from "../common/ModalDialogTitle";

const TpAddUserModal = ({ onSuccess }) => {
  const [open, setOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleSuccess = (message) => {
    setOpen(false);
    setSnackbarMessage(message || "User added successfully");
    setSnackbarSeverity("success");
    setSnackbarOpen(true);
    if (onSuccess) onSuccess();
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  return (
    <>
      <Button variant="contained" color="primary" onClick={handleOpen}>
        Add User
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <ModalDialogTitle onClose={handleClose}>
          Add Tech Prep Admin User
        </ModalDialogTitle>
        <DialogContent>
          <TpAddUser onSuccess={handleSuccess} />
        </DialogContent>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default TpAddUserModal;
